import { get, set } from 'lib/isomorphicLocalStorage'

export const STORAGE_KEY = 'hasSeenTripOnboardingTour'

export function getSeenStatus() {
  return get(STORAGE_KEY) ?? false
}

export function setSeenStatus(hasSeen: boolean) {
  set(STORAGE_KEY, hasSeen)
}
